// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.divider[data-v-0472d794] {\n  background-color: #e4e5e8;\n  margin: 2rem 0;\n  border: none;\n  height: 1px;\n}\n.apartment-info li[data-v-0472d794] {\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1.6;\n}\n.apartment-info li b[data-v-0472d794] {\n  font-weight: 600;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
